export const messageConstant = {
  NoDataFound: "No Data Found",
  Required: "Required!",
  InvalidPasswordPattern:
    "Password must be at least 8 characters long and include at least 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (@, $, !, %, *, ?, &)",
  Invalid: "Invalid!",
  EnterValid: (label) => `Please enter valid ${label?.toLowerCase()}`,
  MinNumberLength: (label, min) => `${label} must be at least ${min} digits`,
  MaxNumberLength: (label, max) =>
    `${label} must be a maximum of ${max} digits`,
  MinCharacterLength: (label, min) =>
    `${label} must be at least ${min} characters`,
  MaxCharacterLength: (label, max) => {
    const formattedLabel =
      label.charAt(0).toUpperCase() + label.slice(1).toLowerCase();
    return `${formattedLabel} is allowed to be a maximum of ${max} characters`;
  },
  MinNumberValue: (label, min) => `${label} must be at least ${min}`,
  MaxNumberValue: (label, max) => `${label} must be at maximum upto ${max}`,
  GreaterThanMessage: (field1, field2) =>
    `${field1} must be greater than ${field2}.`,
  LessThanMessage: (field1, field2) => `${field1} must be less than ${field2}.`,
  MinDateMessage: (minDate) => `Selected date must be on or after ${minDate}.`,
  MaxDateMessage: (maxDate) => `Selected date must be on or before ${maxDate}.`,
  InvalidDateFormat: "Please enter date in 'MM/DD/YYYY' format",
  fileType: (filetype, fileName) =>
    `Only ${filetype} files are allowed. You selected: ${fileName}`,
  ReplicationSiteNameRequired: "WebsiteName.ReplicationSiteNameRequired",
  ReplicationSiteNameSpecialCharacter:
    "WebsiteName.ReplicationSiteNameSpecialCharacter",
  Payment: {
    PaymentAmountDoesNotMatched:
      "All Payment total is not matched with total due",
    PaymentFormTitle: "Add Card Details",
    SubmitFormTitle: "Add Details",
    AddPaymentButtonTitle: "Add Payment Details and Proceed to checkout",
  },
  PaymentProfile: {
    AddPaymentProfileButtonTitle: "Add Payment Profile",
    AddPaymentProfileButtonTitleText: "PaymentProfile.AddPaymentProfile",
  },
  Order: {
    NoTrackingDetailsAvailable: "No tracking details available",
  },
  MemberShipInvoice: {
    InvalidMemberShipItem: "Please add valid membership item",
  },
  InvalidAuthorizationPage: "You're unauthoried to access this page. Please contact administrator.",
};